// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3jeb6","name":"ConsentHeader_name__2Qu3a","birthday":"ConsentHeader_birthday__NIR0H","skeleton":"ConsentHeader_skeleton__4zQAZ"};